var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 47,
    viewBox: "0 0 101 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.193848,
    y: 0.258057,
    width: 99.9807,
    height: 46.5026,
    rx: 23.2513,
    fill: "#1E2631"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5841 38.0093V34.7871L42.1841 33.1759H37.3841C36.5041 33.1759 35.7507 32.8604 35.1241 32.2294C34.4974 31.5984 34.1841 30.8398 34.1841 29.9537V12.2315C34.1841 11.3454 34.4974 10.5868 35.1241 9.95581C35.7507 9.32479 36.5041 9.00928 37.3841 9.00928H50.1841V12.2315H37.3841V29.9537H62.9841V25.1204H66.1841V29.9537C66.1841 30.8398 65.8707 31.5984 65.2441 32.2294C64.6174 32.8604 63.8641 33.1759 62.9841 33.1759H58.1841L59.7841 34.7871V38.0093H40.5841ZM54.9841 28.3426L46.9841 20.2871L49.2241 18.0315L53.3841 22.1801V9.00928H56.5841V22.1801L60.7441 18.0315L62.9841 20.2871L54.9841 28.3426Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download--icon.4c9e4c4fd64c6644e3778719508f8b8b.svg";
export { ForwardRef as ReactComponent };